export const COOKIES_KEYS = {
  UILang: "UILang",
  UIMode: "UIMode",
  EntityPromotionBanner: "entity-promotion-banner",
  AdBlockerBanner: "ad-blocker-banner",
  MatchPrediction: "cw-mp-v1",
  UserPPID: "user-ppid",
} as const;
